export default "__VITE_ASSET__12iI2l6C__"